import { render, staticRenderFns } from "./shopCart.vue?vue&type=template&id=65a4a1b8&scoped=true"
import script from "./shopCart.vue?vue&type=script&lang=js"
export * from "./shopCart.vue?vue&type=script&lang=js"
import style0 from "./shopCart.vue?vue&type=style&index=0&id=65a4a1b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a4a1b8",
  null
  
)

export default component.exports